var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 mt-2"},[_c('div',[_c('div',{staticClass:"d-flex font-weight-bold"},[_c('span',{staticClass:"mr-auto"},[_vm._v(" "+_vm._s(_vm.$t('total'))+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('currency', [_vm.total.toFixed(2)]))+" ")])])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }